export const formatTo12Hour = (timeString: string): string => {
  try {
    // Handle empty or invalid input
    if (!timeString || !/^\d{1,2}:\d{2}$/.test(timeString)) {
      return timeString || 'N/A';
    }

    const [hours, minutes] = timeString.split(':').map(Number);

    // Validate hours and minutes
    if (isNaN(hours) || isNaN(minutes) || 
        hours < 0 || hours > 23 || 
        minutes < 0 || minutes > 59) {
      return timeString;
    }

    const period = hours >= 12 ? 'pm' : 'am';
    const hours12 = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${hours12}:${formattedMinutes} ${period}`;
  } catch (error) {
    console.error('Error formatting time:', error);
    return timeString || 'N/A';
  }
};

export const convertTo24Hour = (timeString: string): string => {
  try {
    // If already in 24-hour format, return as is
    if (/^\d{1,2}:\d{2}$/.test(timeString)) {
      return timeString;
    }

    // Parse 12-hour format (e.g., "2:30 pm" or "11:00 am")
    const match = timeString.toLowerCase().match(/(\d{1,2}):(\d{2})\s*(am|pm)/);
    if (!match) return timeString;

    let [_, hours, minutes, period] = match;
    let hour24 = parseInt(hours, 10);

    if (period === 'pm' && hour24 !== 12) {
      hour24 += 12;
    } else if (period === 'am' && hour24 === 12) {
      hour24 = 0;
    }

    return `${hour24.toString().padStart(2, '0')}:${minutes}`;
  } catch (error) {
    console.error('Error converting time:', error);
    return timeString;
  }
};